var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-share"},[_c('img',{ref:"img",attrs:{"src":require("../../static/img/new-invite/share.jpg")}}),_c('img',{ref:"icon",attrs:{"src":require("../../static/img/new-invite/share-icon.png")}}),_c('canvas',{ref:"canvas",attrs:{"width":"750","height":"1080"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }